import React, { Fragment } from "react";

//import CustomerInfo from '../CustomerInfo';
import "./ConfirmInfo.scss";
//import LocateUser from 'webapp/views/LocateUser/LocateUser';
import { AppState } from "../../enums/AppState";
import { useTranslation } from "react-i18next";

// import editIcon from "assets/ui-img/edit.png";
import { PencilSquareIcon } from "@heroicons/react/24/outline";

import Switch from "webapp/components/Switch/Switch.jsx";
import { CancelOutlined, InsertLinkTwoTone } from "@mui/icons-material";
import { useState } from "react";
import { useEffect } from "react";
import { Alert, AlertTitle } from "@mui/material";
import { devLog } from "utils/devLog";

export default function ConfirmInfo(props) {
  const { t } = useTranslation();

  const load = props.data;
  const [specInsFlag, setSpecInsFlag] = useState(false);
  const [firstName] = useState(load.FirstName);
  const [lastName] = useState(load.LastName);
  const [number] = useState(load.Number);
  const [destCompanyID] = useState(load.DestCompanyID);
  const [year] = useState(load.Year);
  const [color] = useState(load.Color);
  const [model] = useState(load.Model);
  const [make] = useState(load.Make);
  const [lockout] = useState(false);
  const [gas] = useState(false);
  const [start] = useState(false);
  const [tires] = useState(false);
  const [winch] = useState(false);
  const [tow] = useState(false);
  const [gasType] = useState("");
  const [tireType] = useState("");
  const [remain, setRemain] = useState(false); //testing this
  const [highway, setHighway] = useState(false);
  const [specIns, setSpecIns] = useState(load.ServiceDetails);
  const [showErrorMsg, setShowErrorMsg] = useState(false);

  const [showDisablementError, setShowDisablementError] = useState(false);
  const [showDestinationError, setShowDestinationError] = useState(false);
  const [showServiceError, setShowServiceError] = useState(false);
  const [showDestinationCompanyError, setShowDestinationCompanyError] = useState(false);
  const [scheduledEventDate, setScheduledEventDate] = useState("");
  const [serviceType, setServiceType] = useState(props.currState.Service);

  const [fixedDistanceFee, setFixedDistanceFee] = useState(
    props.currState.productServiceTypeLimits?.find((limit) => limit.serviceType === "Tow")?.fixedDistanceFee || 0,
  );

  const [towPrice, setTowPrice] = useState(props.currState?.towPrice || 0);

  const [fixedPrice, setFixedPrice] = useState(
    props.currState.productServiceTypeLimits?.find((limit) => limit.serviceType === serviceType)?.fixedPrice || 0,
  );

  useEffect(() => {
    let formatTime = props.currState.scheduledEventDate
      ? props.currState.scheduledEventDate.toLocaleString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })
      : "";
    setScheduledEventDate(formatTime);
  }, []);
  //secondary parameters like "will you stay with your vehicle",and "are you on the interstate, highway, freeway"
  const tertiaryParam = [
    {
      name: t("description.ConfirmInformationHeaderQuestion1"),
      bool: remain,
      func: () => {
        setRemain(!remain);
      },
      id: "remainid",
    },
    {
      name: t("description.ConfirmInformationHeaderQuestion2"),
      bool: highway,
      func: () => {
        setHighway(!highway);
      },
      id: "highwayid",
    },
  ];

  //function that sends user back to the beginning if they have to edit something
  const onEditUserLocation = () => {
    if (typeof props.onEditUserLocation === "function") {
      props.onEditUserLocation();
    }
  };

  useEffect(() => {
    devLog("props.currState check: ", props.currState.localGroup === "PBFL");
  }, [props.currState]);

  //function that handles the boolean switch statement mess for the service typing
  const ServiceLoad = () => {
    if (lockout) {
      return "Lockout";
    } else if (gas) {
      return "Gas " + gasType;
    } else if (start) {
      return "Start";
    } else if (tires) {
      return "tires " + tireType;
    } else if (winch) {
      return "Winch";
    } else if (tow) {
      return "Tow";
    }
  };

  const onSubmit = (e) => {
    const data = {
      FirstName: firstName,
      LastName: lastName,
      Number: number,
      Year: year,
      Make: make,
      Model: model,
      Color: color,
      Service: ServiceLoad(),
      DestinationAddress: "",
      DestinationCompany: "",
      DestCompanyID: destCompanyID,
      ServiceCenterName: "",
      WillRemainWithAuto: remain,
      OnHighway: props.currState.OnHighway,
      ServiceDetails: specIns,
    };

    let bDisablementError =
      load.DisablementStreet.length < 0 ||
      load.DisablementCity.length < 0 ||
      load.DisablementState.length < 0 ||
      load.DisablementCountry.length < 0 ||
      load.DisablementZip.length < 0;

    let bDestinationError =
      load.DestinationStreet.length < 0 ||
      load.DestinationCity.length < 0 ||
      load.DestinationState.length < 0 ||
      load.DestinationZip.length < 0 ||
      load.DestinationCountry.length < 0;

    let bServiceError = load.Service.length < 0;
    let bDestinationCompanyError = load.DestinationCompany.length < 0;

    setShowDisablementError(bDisablementError);
    setShowDestinationError(bDestinationError);
    setShowServiceError(bServiceError);
    setShowDestinationCompanyError(bDestinationCompanyError);

    if (bServiceError || bDisablementError || bDestinationCompanyError || bServiceError || bDestinationCompanyError) {
      setShowErrorMsg(true);
      return;
    } else {
      if (typeof props.onUserNext === "function") {
        props.onUserNext(data);
      }
    }
  };

  const progress = () => {
    setSpecInsFlag(true);
  };

  const onUserCancel = () => {
    devLog("UI Cancel pressed");
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  //devLog(load)
  return (
    <div className="confirmForm">
      {!specInsFlag && (
        <Fragment>
          {/* Selected Service */}
          <div>
            <div className="flexItem2">
              <div className="text_2">
                <strong>{t("description.ConfirmInformationSelectedService")}</strong>
                <small>
                  {load.Service == "Boost"
                    ? props.locale === "CA"
                      ? t(
                          "description.ConfirmServicesBoostCA",
                          // +
                          //   (props.localGroup === "TVL" ? "TVL" : "")
                        )
                      : t("description.ConfirmServicesBoost" + (props.localGroup === "TVL" ? "TVL" : ""))
                    : load.Service}
                </small>
              </div>
              <button
                onClick={() => {
                  props.onEditService(AppState.SelectService);
                }}
                className="button"
              >
                <PencilSquareIcon style={{ width: 32, color: "black", cursor: "pointer" }} />
              </button>
            </div>
            {showErrorMsg && showServiceError && (
              <Alert severity="error">
                <AlertTitle> {t("description.IncompleteInfoError")}</AlertTitle>
                {t("description.IncompleteServiceMsg")}
              </Alert>
            )}
          </div>
          {/* Current Vehicle Location*/}
          <div>
            <div className="flexItem2">
              <div className="text_2">
                <strong>{t("description.ConfirmInformationCurrentLocation")}</strong>
                <small>{load.DisablementAddress}</small>
              </div>
              <button
                onClick={() => {
                  onEditUserLocation();
                }}
                className="button"
              >
                <PencilSquareIcon style={{ width: 32, color: "black", cursor: "pointer" }} />
              </button>
            </div>
            {showErrorMsg && showDisablementError && (
              <Alert severity="error">
                <AlertTitle> {t("description.IncompleteInfoError")}</AlertTitle>
                {t("description.IncompleteAddressMsg")}
              </Alert>
            )}
          </div>

          {/* Service Center Name */}
          {load.Service === "Tow" && load.DestinationCompany !== load.DestinationAddress && (
            <div>
              <div className="flexItem2">
                <div className="text_2">
                  <strong>{t("description.ConfirmInformationServiceCenterName")}</strong>
                  <small>{load.DestinationCompany}</small>
                  {load.DisablementAddress.length < 0 && <Alert severity="error">Please fill out this field</Alert>}
                </div>
                <button
                  onClick={() => {
                    props.onEditDestination(AppState.SelectDestination);
                  }}
                  className="button"
                >
                  <PencilSquareIcon style={{ width: 32, color: "black", cursor: "pointer" }} />
                </button>
              </div>
              {showErrorMsg && showDestinationCompanyError && (
                <Alert severity="error">
                  <AlertTitle>{t("description.IncompleteInfoError")}</AlertTitle>
                  {t("description.IncompleteDestinationCenterMsg")}
                </Alert>
              )}
            </div>
          )}
          {/* Tow To Address */}
          {load.Service === "Tow" && load.DestinationObj.address && (
            <div>
              <div className="flexItem2">
                <div className="text_2">
                  <strong>{t("description.ConfirmInformationTowToAddress")}</strong>
                  <small>{load.DestinationAddress}</small>
                </div>
                <button
                  onClick={() => {
                    props.onEditDestination(AppState.SelectDestination);
                  }}
                  className="button"
                >
                  <PencilSquareIcon
                    style={{
                      width: 32,
                      color: "black",
                      cursor: "pointer",
                    }}
                  />
                </button>
              </div>
              {showErrorMsg && showDestinationError && (
                <Alert severity="error">
                  <AlertTitle>{t("description.IncompleteInfoError")}</AlertTitle>
                  {t("description.IncompleteAddressMsg")}
                </Alert>
              )}
            </div>
          )}
          {/* Tow Distance */}
          {load.Service === "Tow" && load.towDistance && (
            <div>
              <div className="flexItem2">
                <div className="text_2">
                  <strong>
                    {/* {t("description.ConfirmInformationTowToAddress")} */}
                    Tow Distance:
                  </strong>
                  <small>
                    {" "}
                    {load.towDistance} {load.towDistanceUnit}
                  </small>
                </div>
                {/* <button
                  onClick={() => {
                    props.onEditDestination(AppState.SelectDestination);
                  }}
                  className="button"
                >
                  <PencilSquareIcon
                    style={{
                      width: 32,
                      color: "black",
                      cursor: "pointer",
                    }}
                  />
                </button> */}
              </div>
              {/* {showErrorMsg && showDestinationError && (
                <Alert severity="error">
                  <AlertTitle>{t("description.IncompleteInfoError")}</AlertTitle>
                  {t("description.IncompleteAddressMsg")}
                </Alert>
              )} */}
            </div>
          )}

          {load.Service === "Tow" && props.currState.localGroup === "PBFL" && towPrice >= 0 && (
            <div>
              <div className="flexItem2">
                <div className="text_2">
                  <strong>Tow Cost: </strong>${towPrice}
                </div>
              </div>
            </div>
          )}

          {props.currState.localGroup === "PBFL" && serviceType !== "Tow" && (
            <div>
              <div className="flexItem2">
                <div className="text_2">
                  <strong>{serviceType} Cost: </strong>${fixedPrice || 0}
                </div>
              </div>
            </div>
          )}

          {/* Schedule Service Time */}
          {scheduledEventDate && (
            <div>
              <div className="flexItem2">
                <div className="text_2">
                  <strong>{t("description.ConfirmScheduleServiceTime")}</strong>
                  <small>{scheduledEventDate}</small>
                </div>
                <button
                  onClick={() => {
                    props.onEditDestination(AppState.SelectService);
                  }}
                  className="button"
                >
                  <PencilSquareIcon
                    style={{
                      width: 32,
                      color: "black",
                      cursor: "pointer",
                    }}
                  />
                </button>
              </div>
            </div>
          )}
          {/* {load.DestinationObj.address && (
            <div className="flexItem2">
              <div className="text_2">
                <strong>Tow To Address: </strong>
                <small>{load.DestinationAddress}</small>
              </div>
              <button
                onClick={() => {
                  props.onEditDestination(AppState.SelectDestination);
                }}
                className="button"
              >
                <PencilSquareIcon
                  style={{ width: 32, color: "black", cursor: "pointer" }}
                />
              </button>
            </div>
          )} */}
          {/* {showErrorMsg && (
            <Alert severity="error">
              <AlertTitle> {t("description.IncompleteInfoError")}</AlertTitle>
              {t("description.IncompleteInfoMsg")}
            </Alert>
          )} */}
          <div className="flexItem2">
            <textarea
              className="w-full bg-red mb-10"
              style={{
                width: "100%",
                background: "white",
                marginTop: "5px",
                marginBottom: "-5px",
                borderWidth: "1px",
                borderColor: "rgb(171, 171, 171)",
                padding: "10px",
                margin: "0.5em",
                borderRadius: "3px",
              }}
              placeholder="Do you have any special requests and instructions for us to consider..."
              value={specIns}
              onChange={(e) => {
                setSpecIns(e.target.value);
              }}
            />
          </div>
          <div className="footerContainer" style={{ display: "flex" }}>
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={onUserCancel}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <div>
              <button onClick={onSubmit} className="ui-btn">
                {t("description.ConfirmDestinationListButton")}
              </button>
            </div>
          </div>
          {/* <div className="flexItem">
						<button onClick={progress} className="ui-btn">
							{t("description.ConfirmDestinationListButton")}
						</button>
					</div> */}
        </Fragment>
      )}
      {specInsFlag && (
        <Fragment>
          <Fragment>
            <Switch
              IO={tertiaryParam[0]}
              func={() => {
                setRemain(!remain);
              }}
            />
            <Switch
              IO={tertiaryParam[1]}
              func={() => {
                setHighway(!highway);
              }}
            />

            <div className="flexItem2">
              <textarea
                style={{
                  width: "100%",
                  background: "white",
                  marginTop: "5px",
                  marginBottom: "-5px",
                  borderWidth: "1px",
                  borderColor: "rgb(171, 171, 171)",
                  padding: "10px",
                  margin: "0.5em",
                  borderRadius: "3px",
                }}
                placeholder="Do you have any special requests and instructions for us to consider..."
                color="#1E90FF"
                value={specIns}
                onChange={(e) => {
                  setSpecIns(e.target.value);
                }}
              />
            </div>

            <div className="footerContainer" style={{ display: "flex" }}>
              <div>
                <button
                  id="cancelButton"
                  type="button"
                  className="footer"
                  style={{
                    background: "#f4f4f4",
                    color: "black",
                    paddingLeft: 14,
                  }}
                  onClick={onUserCancel}
                >
                  <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                  <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
                </button>
              </div>
              <div>
                <button onClick={onSubmit} className="ui-btn">
                  {t("description.ConfirmDestinationListButton")}
                </button>
              </div>
            </div>
          </Fragment>
        </Fragment>
      )}
    </div>
  );
}
